module.exports = __webpack_public_path__ + "img/qrcode-zijie.eb0b7253.png";